import ReactCountryFlag from 'react-country-flag';
import React from 'react';

export const optionsLanguage = [
  {
    value: 'uz',
    label: (
      <div className="d-flex align-items-center gap-1">
        <ReactCountryFlag countryCode="UZ" svg style={{ width: '1.5em', height: '1.5em' }} />
        <span>O'Z</span>
      </div>
    ),
  },
  {
    value: 'ru',
    label: (
      <div className="d-flex align-items-center gap-1">
        <ReactCountryFlag countryCode="RU" svg style={{ width: '1.5em', height: '1.5em' }} />
        <span>РУС</span>
      </div>
    ),
  },
  {
    value: 'en',
    label: (
      <div className="d-flex align-items-center gap-1">
        <ReactCountryFlag countryCode="GB" svg style={{ width: '1.5em', height: '1.5em' }} />
        <span>ENG</span>
      </div>
    ),
  },
];
export const optionsLanguageMobile = [
  {
    label: 'Uz',
    value: 'uz',
  },
  {
    label: 'En',
    value: 'en',
  },
  {
    label: 'Ru',
    value: 'ru',
  },
];
